import React from 'react';
import './FormInput.css';

const FormInput = ({
  label,
  type = 'text',
  id,
  value,
  onChange,
  onBlur,
  error,
  touched,
  required = false,
  placeholder,
  autoComplete,
  ...props
}) => {
  const inputId = id || `input-${label.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <div className="form-group">
      <label htmlFor={inputId}>
        {label}
        {required && <span className="required">*</span>}
      </label>
      <input
        id={inputId}
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder={placeholder}
        autoComplete={autoComplete}
        className={`form-input ${error && touched ? 'error' : ''} ${touched && !error ? 'valid' : ''}`}
        {...props}
      />
      {error && touched && (
        <div className="input-error">
          <span className="error-icon">⚠</span>
          {error}
        </div>
      )}
      {touched && !error && value && (
        <div className="input-success">
          <span className="success-icon">✓</span>
          Valid
        </div>
      )}
    </div>
  );
};

export default FormInput; 